import { useDispatch, useSelector } from 'react-redux'
import { GameState } from '../../../redux/types/game'
import { getGameSelector } from '../../../redux/selectors/gameSelectors'
import { useNavigate, useParams } from 'react-router-dom'
import React, { useEffect } from 'react'
import Confetti from '../components/Confetti'
import * as DOMPurify from 'dompurify'
import jwt_decode from 'jwt-decode'
import { ArrowCircleRight2, ArrowRight, Map } from 'iconsax-react'
import { Button } from 'primereact/button'
import useSound from 'use-sound'
import clickSoundEffect from '../../../assets/audio/click2.wav'
import { useTranslation } from 'react-i18next'
import { fetchIsQuestionSolvedRequest } from '../../../redux/actions/gameActions'
import Loading from '../../../components/Loading'
import { decodeIframeString } from '../../../utils/decodeIframeString'

const WellDone = () => {
  const { questionId, localeId }: any = useParams()
  const {
    data: {
      questionByLocale,
      puzzleAnswer,
      wellDoneBackground,
      volumeGlobal,
      solvedPuzzles,
      branding,
    },
    loading: { isLoadingIsPuzzleSolved },
  }: GameState = useSelector(getGameSelector)

  const token = localStorage.getItem('tokenCityHunt') ?? ''

  const { GameType, HasFinalPuzzle }: any = jwt_decode(token)

  const navigate = useNavigate()

  const { t } = useTranslation()

  const [clickSound] = useSound(clickSoundEffect, {
    volume: volumeGlobal,
  })

  const dispatch = useDispatch()

  useEffect(() => {
    return () => {
      dispatch({ type: 'RESET_PUZZLE_ANSWER' })
    }
  }, [])

  useEffect(() => {
    if (!puzzleAnswer) {
      dispatch(
        fetchIsQuestionSolvedRequest({
          questionId,
          localeId,
          reason: 'welldone',
        }),
      )
    }
  }, [puzzleAnswer])

  useEffect(() => {
    if (
      solvedPuzzles &&
      solvedPuzzles[questionId] &&
      solvedPuzzles[questionId] === false
    ) {
      navigate(`/game/${questionId}/${localeId}`)
    }
  }, [solvedPuzzles])

  const sanitizedData = (data: string) => ({
    __html: DOMPurify.sanitize(data, {
      ADD_TAGS: ['iframe'],
      ADD_ATTR: ['src', 'class', 'allowfullscreen', 'frameborder'],
    }),
  })

  const renderButton = (puzzle: any) => {
    const endScreenBtn = (
      <div style={{ width: '100%' }} className="flex justify-content-center">
        <Button
          label={t('FinishGame')}
          onClick={() => {
            clickSound()
            navigate('/end')
          }}
          type="button"
          // icon={<AlignBottom color="#fff" variant="Bold" className="mr-1" />}
          icon={
            <>
              <div
                className="p-2 p-button-icon p-button-icon-right rounded-icon-style"
                style={{
                  backgroundColor: branding?.buttonPrimary.textColor,
                }}
              >
                {/* <div className="p-2 p-button-icon p-c p-button-icon-right border-circle bg-white"> */}
              </div>
              <ArrowRight
                color="#fff"
                className="icon-center"
                style={{
                  color: branding?.buttonPrimary.backgroundColor,
                }}
                // className="p-button-icon p-c p-button-icon-right"
              />
            </>
          }
          className="p-button-rounded mt-5 p-button-raised w-full uppercase"
          style={{
            backgroundColor: branding?.buttonPrimary.backgroundColor,
            color: branding?.buttonPrimary.textColor,
          }}
          // className="p-button-rounded mt-5 p-button-raised w-full sign-in-btn"
        />
      </div>
    )

    if (puzzle.isFinalPuzzle) {
      // go to end screen

      return endScreenBtn
    } else if (puzzle.isLastPuzzle) {
      if (HasFinalPuzzle.toLowerCase() === 'true') {
        // go to final puzzle description screen
        return (
          <div
            style={{ width: '100%' }}
            className="flex justify-content-center"
          >
            <Button
              label={t('GoToFinalPuzzle')}
              onClick={() => {
                clickSound()
                navigate(`/game/final-puzzle/${localeId}`)
              }}
              type="button"
              // icon={
              //   <ArrowCircleRight2
              //     color="#fff"
              //     variant="Bold"
              //     className="mr-1"
              //   />
              // }
              icon={
                <>
                  <div
                    className="p-2 p-button-icon p-button-icon-right rounded-icon-style"
                    style={{
                      backgroundColor: branding?.buttonPrimary.textColor,
                    }}
                  >
                    {/* <div className="p-2 p-button-icon p-c p-button-icon-right border-circle bg-white"> */}
                  </div>
                  <ArrowCircleRight2
                    color="#fff"
                    variant="Bold"
                    className="icon-center"
                    style={{
                      color: branding?.buttonPrimary.backgroundColor,
                    }}
                    // className="p-button-icon p-c p-button-icon-right"
                  />
                </>
              }
              className="p-button-rounded mt-5 p-button-raised w-full"
              style={{
                backgroundColor: branding?.buttonPrimary.backgroundColor,
                color: branding?.buttonPrimary.textColor,
              }}
              // className="p-button-rounded mt-5 p-button-raised w-full sign-in-btn"
            />
          </div>
        )
      } else {
        // go to end screen
        return endScreenBtn
      }
    } else {
      // btn back to map

      return (
        <div style={{ width: '100%' }} className="flex justify-content-center">
          <Button
            label={
              GameType !== 'Indoor' ? t('BackToMap') : t('BackToMainScreen')
            }
            onClick={() => {
              clickSound()
              navigate('/game')
            }}
            type="button"
            // icon={<Map color="#fff" variant="Bold" className="mr-1" />}
            icon={
              <>
                <div
                  className="p-2 p-button-icon p-button-icon-right rounded-icon-style"
                  style={{
                    backgroundColor: branding?.buttonPrimary.textColor,
                  }}
                >
                  {/* <div className="p-2 p-button-icon p-c p-button-icon-right border-circle bg-white"> */}
                </div>
                <Map
                  color="#fff"
                  variant="Bold"
                  className="icon-center"
                  style={{
                    color: branding?.buttonPrimary.backgroundColor,
                  }}
                  // className="p-button-icon p-c p-button-icon-right"
                />
              </>
            }
            className="p-button-rounded mt-5 p-button-raised  w-full"
            style={{
              backgroundColor: branding?.buttonPrimary.backgroundColor,
              color: branding?.buttonPrimary.textColor,
            }}
            // className="p-button-rounded mt-5 p-button-raised  w-full sign-in-btn"
          />
        </div>
      )
    }
  }

  if (isLoadingIsPuzzleSolved || !puzzleAnswer) {
    return <Loading />
  }

  return (
    <>
      <Confetti />
      {/* <div
        className="flex flex-wrap justify-content-between"
        id="game-puzzle"
        style={{ height: '100%', width: '100%' }}
      > */}
      <div
        className="p-2"
        // className="m-2"
        style={{
          // minHeight: '100%',
          minHeight: '100vh',
          // backgroundRepeat: 'no-repeat',
          backgroundSize: 'contain',
          backgroundPosition: 'center',
          backgroundImage:
            wellDoneBackground !== null && wellDoneBackground !== ''
              ? `url('${wellDoneBackground}')`
              : '',
          // backgroundImage: wellDoneBackground ? wellDoneBackground : '',
        }}
      >
        <div
          style={{ overflowWrap: 'break-word' }}
          className="img-full-width ql-editor"
          dangerouslySetInnerHTML={sanitizedData(
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            decodeIframeString(puzzleAnswer?.wellDoneHtml ?? '') ?? '',
          )}
        />
        {HasFinalPuzzle.toLowerCase() === 'true' &&
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          !puzzleAnswer?.isFinalPuzzle && (
            <div className="flex justify-content-center w-full">
              <img
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                src={puzzleAnswer?.collectedItemImageUrl}
                // src="/assets/layout/images/logo.png"
                alt="inventory"
                // className="md:ml-auto block md:h-full"
                // className="mx-auto"
                style={{
                  // clipPath: 'polygon(8% 0, 100% 0%, 100% 100%, 0 100%)',
                  // width: 'inherit',
                  maxWidth: '100%',
                  textAlign: 'center',
                }}
              />
            </div>
          )}
        {renderButton(puzzleAnswer)}
      </div>
    </>
  )
}

export default WellDone
